import { theme } from 'antd';
import type { ThemeConfig } from 'antd';
const { compactAlgorithm } = theme;

export const secondaryColor = '#00D38C'; // secondary riêng

const lightTheme: ThemeConfig = {
  components: {
    Divider: {
      colorSplit: '#f1f1f1'
    },
    Layout: {
      siderBg: '#103c62',
      triggerBg: '#1c4569',
      lightTriggerBg: '#ededed',
      triggerColor: '#fff'
    },
    Menu: {
      darkSubMenuItemBg: '#1c4569',
      darkItemBg: '#103c62',
      darkPopupBg: '#103c62',
      darkItemColor: '#fff',
      popupBg: '#f9f8f8',
      fontSize: 12
    },
    Modal: {
      // Nút primary trong footer Modal
      colorPrimary: '#00B2FF', // màu nền
      colorPrimaryHover: '#0090CC', // hover
      colorPrimaryActive: '#0077AA', // active
      colorTextHeading: '#1E293B' // màu tiêu đề modal
    },
    Table: { fontSize: 13 },
    Card: { fontSize: 13 },
    Form: { fontSize: 13, itemMarginBottom: 10 },
    Descriptions: { fontSize: 13 },
    Button: { fontSize: 13 }
  },
  algorithm: compactAlgorithm,
  token: {
    colorSplit: 'grey',
    colorTextDisabled: 'rgba(0, 0, 0, 0.62)',
    // fontSize: 13
    // colorPrimary: '#00B2FF', // Primary
    colorSuccess: '#22C55E',
    colorWarning: '#FFC107',
    colorError: '#EF4444',
    colorInfo: '#3B82F6',

    // colorBgBase: '#FFFFFF', // background body
    // colorBgContainer: '#F7F9FB', // background của card, modal, input

    colorTextBase: '#1E293B', // màu text chính (title)
    colorTextSecondary: '#64748B', // màu text phụ
    colorBorder: '#E2E8F0', // màu viền

    // Optional thêm cho đẹp
    // colorLink: '#00B2FF', // link color
    // colorLinkHover: '#0090CC', // hover link

    borderRadius: 8 // bo góc chung (8px cho đẹp hiện đại)
  }
};
export default lightTheme;
